module.exports = __webpack_public_path__ + "img/1f4a9.96bc427.svg";